module.exports = "<div class=\"shipping-asn-details-rows-view q-marg-vert-md\"> <div class=\"q-input-group q-marg-vert-lg\"> <h2 class=q-section-title> <span> <span class=case-pallet-title>Pallet</span> Information </span> </h2> </div> <div class=\"shipping-asn-details-rows-outer q-section-border-top q-marg-vert-md\"> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/asns/ShippingTab/html/asnDetailRowsView.html
// module id = 284
// module chunks = 1